import { Component, OnInit, Inject } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import * as _ from 'lodash';
import { Http, RequestOptions } from '@angular/http';
import { SharedDataService } from '../../shared-data.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-export-data-modal',
  templateUrl: './export-data-modal.component.html',
  styleUrls: ['./export-data-modal.component.scss']
})
export class ExportDataModalComponent implements OnInit {

  url: string;
  windowsUrl: string;
  options: any;
  email: string;
  title: string;
  items: Array<any>;
  mergeFiles: boolean;
  reportName: string;
  summaryReport: boolean;
  detailsReport: boolean;
  requestOptions: RequestOptions;
  currency: boolean;

  startLoading() {
    this.loadingBar.start();
  }

  stopLoading() {
    this.loadingBar.complete();
  }

  constructor(
    private http: Http,
    private matSnackbar: MatSnackBar,
    public sharedDataService: SharedDataService,
    private loadingBar: LoadingBarService,
    @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    public dialogRef: MatDialogRef<ExportDataModalComponent>
  ) { 
    this.initVars();
    this.initModalTitle();
    this.setupModalUI();
  }

  ngOnInit() {
  }

  initVars() {
    this.email = '';
    this.url = this.sharedDataService.apiUrl;
    this.windowsUrl = this.sharedDataService.windows_url !== null ? this.sharedDataService.windows_url : this.sharedDataService.apiUrl;
    this.requestOptions = this.sharedDataService.returnRequestOptions();
  }

  initModalTitle() {
    const modalOptions = this.matDialogData.options;
    this.reportName = modalOptions.reportName;
    modalOptions.showReportOption ? this.title = 'Select Export Report Type' : this.title = 'Enter Email';
  }

  setupModalUI() {
    this.options = this.matDialogData.options;
  }

  isMergeChecked() {
    return this.mergeFiles ? true : false;
  }

  isSummaryReportChecked() {
    return this.summaryReport ? true : false;
  }

  isDetailsReportChecked() {
    return this.detailsReport ? true : false;
  }

  showEnterEmailToast() {
    this.matSnackbar.open('Enter your email address', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showExportSuccessToast() {
    this.matSnackbar.open('An email has been sent successfully with an attached report', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showExportFailureToast() {
    this.matSnackbar.open('An error occured. Please try again later.', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showMergeSuccessToast() {
    this.matSnackbar.open('PDF merged, please check your email in 3 minutes', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showMergeFailureToast() {
    this.matSnackbar.open('PDF merge failed.', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  doExport() {
    this.mergeFiles ? this.mergePdfFiles() : this.postExport();
  }

  ValidateEmail(){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)){
      return (true)
    }
    return (false)
  }

  postExport() {
    this.startLoading();
    this.items = this.matDialogData.collection;
    const url = this.url + '/utility/export_data?' + this.sharedDataService.getActivityForUrl(undefined, 'Export Information');

    const body = {
      Items: [],
      Recepient_Email: this.email,
      Report_Name: this.reportName,
      School_Name: this.sharedDataService.school_name,
      School_Email: this.sharedDataService.school_email,
      School_Identifier: parseInt(this.sharedDataService.school_id),
    };

    //validate email
    if(!this.ValidateEmail()){
      this.celebrate("Please Enter a valid Email","Okay");
      this.stopLoading();
      return 0;
    }

    if (this.matDialogData.curr !== undefined) {
      this.items.forEach(item => {
        let stat = item.Bill_Status == 'Partially' ? 'Partially Paid' : item.Bill_Status;
        body.Items.push({
          Student: item.Name,
          Classroom: item.Classroom_Name,
          Currency: this.matDialogData.curr,
          Status: stat, 
          ['Bill Amount']:parseFloat(item.Original_Amount).toFixed(2),
          ['Amount Paid']: stat=="Unpaid"?0:(parseFloat(item.Original_Amount) - parseFloat(item.Amount)).toFixed(2), //(Math.round(item.AmountToShow * 100) / 100).toFixed(2)
          ['Amount Remaining']:(parseFloat(item.Amount)).toFixed(2),
          ['Due Date']: item.Due_Date?item.Due_Date.substr(0,10):item.Due_Date,
          ['Transaction Description']:item.Transaction_Description,
        });
      });
    } 
    else {
      this.items.forEach(item => {
        let stat = item.Bill_Status == 'Partially' ? 'Partially Paid' : item.Bill_Status;
        body.Items.push({
          Student: item.Name,
          Classroom: item.Classroom_Name,
          Currency: item.Currency_Short_Symbol,
          Status: stat,
          ['Bill Amount']:parseFloat(item.Original_Amount).toFixed(2),
          ['Amount Paid']: stat=="Unpaid"?0:(parseFloat(item.Original_Amount) - parseFloat(item.Amount)).toFixed(2), //(Math.round(item.AmountToShow * 100) / 100).toFixed(2)
          ['Amount Remaining']:(parseFloat(item.Amount)).toFixed(2),
          ['Due Date']: item.Due_Date?item.Due_Date.substr(0,10):item.Due_Date,
          ['Transaction Description']:item.Transaction_Description,

        });
      });  
    }

    this.http.post( url, body, this.requestOptions ).subscribe(
      res => { 
      this.stopLoading();
      this.showExportSuccessToast();
        this.dialogRef.close();
      },
      err => { 
      this.stopLoading();
      this.showExportFailureToast();
        this.dialogRef.close();
      }
    );
  }

  mergePdfFiles() {
    this.startLoading();
    this.items = this.matDialogData.collection;
    let url;
    if (this.sharedDataService.windows_url !== null) {
      url = this.sharedDataService.apiUrl + '/utility/merge_pdf';
    }
    else{
      url = this.windowsUrl == this.url ? this.windowsUrl + '/utility/merge_pdf' : this.windowsUrl + 'utility/merge_pdf';
    }
    let tokenInfo = JSON.parse(sessionStorage.getItem('tokenInfo'));

    const body = {
      URL: [],
      Type_Id: [],
      Type: 'GeneralLedger',
      Report_Name: this.reportName,
      User_Identifier: parseInt(this.sharedDataService.user_id),
      School_Name: this.sharedDataService.school_name,
      School_Email: tokenInfo.School_Identifier[0].Financial_Email || this.sharedDataService.school_email,
      School_Identifier: parseInt(this.sharedDataService.school_id),
      Email: _.isEmpty(this.email) ? this.sharedDataService.school_email : this.email,
      Recepient_Email: _.isEmpty(this.email) ? this.sharedDataService.school_email : this.email
    };

    this.items.forEach(item => {
      if (item.Bill_Payment_Receipt_S3_URL !== null && item.Bill_Payment_Receipt_S3_URL !== "") {
        body.URL.push(item.Bill_Payment_Receipt_S3_URL);
        body.Type_Id.push(item.General_Ledger_Identifier);          
      }
    });
    
    
    
    this.http.post( url, body, this.requestOptions ).subscribe(
      res => { 
        this.stopLoading();
        this.showMergeSuccessToast();
        this.dialogRef.close();
      },
      err => { 
        this.stopLoading();
        this.showMergeFailureToast();
        this.dialogRef.close();
      }
    );
  }

  exportData() {
    this.doExport();
  }

  celebrate(message,action){
    this.matSnackbar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/export-data-modal/export-data-modal.component.ts